import React, { lazy } from 'react';
import { OfferBox } from './OfferBox';
import { UrgencyBadges } from './UrgencyBadges';
import { CTAButton } from './CTAButton';
import { SecurityBadges } from './SecurityBadges';
const placeholderImg = 'https://digitalearnpro.com/wp-content/uploads/2025/09/20250930_1424_Espacio-para-tu-Imagen_simple_compose_01k6dtcpvgec9s48a98jsekbnr.png';
export function FinalOfferSection() {
  return <section className="bg-primary-dark text-white text-center py-12 px-[15px] relative" data-id="element-91">
      <div className="max-w-[500px] mx-auto px-[15px]" data-id="element-92">
        <h2 className="text-[26px] mb-6 leading-[1.2] font-bold text-white heading-underline" data-id="element-93">
          ¡Consigue acceso ahora y empieza a cocinar!
        </h2>
        <p className="text-[#ddd] text-[15px] leading-[1.6] mb-8" data-id="element-94">
          Obtén <strong data-id="element-95">50 recetas personalizadas</strong> y{' '}
          <strong data-id="element-96">5 bonus exclusivos</strong> por un único pago. Empieza tu
          transformación hoy mismo.
        </p>

        <div className="my-6 mx-auto overflow-hidden shadow-[0_8px_20px_rgba(0,0,0,0.08)] rounded-lg relative max-w-full" data-id="element-97">
          <img loading="lazy" alt="Consigue acceso ahora y empieza a cocinar" src="https://cdn.magicpatterns.com/uploads/5mZ2juetVSSZty8CXy5QCs/Gemini_Generated_Image_2jjy2l2jjy2l2jjy.jpg" className="w-full h-auto block rounded-lg" data-id="element-98" />
        </div>

        <div className="text-center my-[30px] mx-auto mb-[20px]" data-id="element-99">
          <p className="text-[11px] font-semibold text-[#ccc] tracking-[1px] uppercase mb-2" data-id="element-100">
            +5.820 DESCARGAS
          </p>
          <h1 className="text-[18px] font-bold leading-[1.4] text-white" data-id="element-101">
            📦 Pack de Recetas Personalizadas + 5 Bonus Exclusivos 🎁
          </h1>
        </div>

        <OfferBox data-id="element-102" />

        <UrgencyBadges data-id="element-103" />

        <CTAButton href="https://kleoyshop.com/cart/add?id=52708878745928&quantity=1" className="mt-8" data-id="element-104">
          ¡Quiero mi pack ahora!
        </CTAButton>

        <SecurityBadges data-id="element-105" />
      </div>
    </section>;
}